// utils/auth.js
export function checkTokenExpiration() {
  const token = localStorage.getItem('jwt');
  const issuedAt = localStorage.getItem('jwt_issued_at');
  const fifteenMinutes = 60 * 60 * 1000; // one hour now
  const currentTime = new Date().getTime();

 // console.log('Token and issuedAt:', token, issuedAt); // Debug log
  if (token && issuedAt) {
    const elapsedTime = currentTime - issuedAt;
    //console.log('Elapsed time (ms):', elapsedTime); // Debug log
    if (elapsedTime > fifteenMinutes) {
      //console.log('Token expired'); // Debug log
      localStorage.removeItem('jwt');
      localStorage.removeItem('role');
      localStorage.removeItem('jwt_issued_at');
      return false;
    } else {
      // Store  timestamp in localStorage
      const issuedAt = new Date().getTime();
     // console.log('Storing issuedAt:', issuedAt); // Debug log    
      localStorage.setItem('jwt_issued_at', issuedAt);
      //console.log('Token is still valid'); // Debug log
      return true;
    }
  } else {
    return false;
  }
}
